/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Layout from "../../../../components/layout/Layout";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import { Helmet } from "react-helmet";
import HolidayPayAmount from "./HolidayPayAmount";
import { HolidayTransactionHistory } from "./HolidayTransactionHistory";
import Loader from "components/Loader";
import Pagination from "react-bootstrap/Pagination";
import { PayoutFilter } from "../holiday-pension-filters/PayoutFilter";
import { HolidayPayPDFModal } from "./HolidayPayPDFModal";
import { mobileScroll } from "common/FunctionUtils";
import { LOCALES } from "common/constants";

const HolidayPay = () => {
  const { t } = useTranslation();
  const language = localStorage.getItem("i18nextLng");

  const year = new Date().getUTCFullYear();

  const [loading, setLoading] = useState(false);

  const [toolTipError, setToolTipError] = useState({
    invalidFromdate: false,
    toDateNotSelected: false,
    fromDateNotSelected: false,
    lessPayAmount: false,
  });

  const [date, setDate] = useState({
    from: "",
    to: "",
  });

  const [tFilterDate, setTFilterDate] = useState({
    from: "",
    to: "",
  });

  const [spinner, setSpinner] = useState({
    spinner: false,
    Year: year,
  });

  const [incomeData, setincomeData] = useState({
    values: {},
    statusCode: null,
    usingDates: false,
  });

  const [show, setShow] = useState({
    PDFModal: false,
    HISModal: false,
  });
  const [isPayShow, setPayShow] = useState(false);
  const [payOutAmount, setPayOutAmount] = useState(0);
  const [hideNote, setHideNote] = useState(false);
  const pageCount = 10;
  const [totalCount, setTotalCount] = useState();
  const [activePagination, setactivePagination] = useState(1);

  const [holidaySavingsData, setHolidaySavingsData] = useState([]);
  const [filteredMonth, setFilteredMonth] = useState();
  const [filteredYear, setFilteredYear] = useState();
  const [showAllHistory, setShowAllHistory] = useState(true);

  const [showAllHistoryPayout, setShowAllHistoryPayout] = useState(true);
  const [filteredMonthPayout, setFilteredMonthPayout] = useState();
  const [filteredYearPayout, setFilteredYearPayout] = useState();

  useEffect(() => {
    downloadData();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setToolTipError({
        toDateNotSelected: false,
      });
    }, 6000);
  }, [toolTipError]);

  const downloadData = async () => {
    try {
      if (date.from && date.to && date.from <= date.to) {
        setSpinner({
          ...spinner,
          spinner: true,
        });
        const res = await axios.get(
          `/salary/holiday-pension?fromDate=${date.from}&toDate=${date.to}`
        );
        setincomeData({
          values: res.data.response,
          statusCode: res.status,
          usingDates: true,
        });
        setSpinner({
          ...spinner,
          spinner: false,
        });
      } else if (date.from && date.to && date.from > date.to) {
        setToolTipError({
          invalidFromdate: true,
        });
      } else if (!date.from && date.to) {
        setToolTipError({
          fromDateNotSelected: true,
        });
      } else if (!date.to && date.from) {
        setToolTipError({
          toDateNotSelected: true,
        });
      } else if (!date.from && !date.to) {
        setSpinner({
          ...spinner,
          spinner: true,
        });
        const res = await axios.get(`/salary/holiday-pension`);
        setincomeData({
          values: res.data.response,
          statusCode: res.status,
        });
        setSpinner({
          ...spinner,
          spinner: false,
        });
      }
    } catch (error) {
      setSpinner({
        ...spinner,
        spinner: false,
      });
    }
  };

  const handleDownloadPDF = () => {
    const element = document.getElementById("salary-modal");
    if (element) {
      html2canvas(element).then((canvas) => {
        const imgWidth = 210;
        const pageHeight = 290;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;
        const doc = new jsPDF("p", "mm"); // eslint-disable-line new-cap
        let position = 0;
        const pageData = canvas.toDataURL("image/jpeg", 1.0);
        const imgData = encodeURIComponent(pageData);
        doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        doc.setLineWidth(5);
        doc.setDrawColor(255, 255, 255);
        doc.rect(0, 0, 210, 295);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          doc.addPage();
          doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
          doc.setLineWidth(5);
          doc.setDrawColor(255, 255, 255);
          doc.rect(0, 0, 210, 295);
          heightLeft -= pageHeight;
        }
        doc.save("holiday-payout-details.pdf");
      });
    }
    setShow({ PDFModal: false });
  };
  const holidayPayoutRequest = async () => {
    try {
      setSpinner({
        ...spinner,
        spinner: true,
      });
      await axios.post(`/salary/holiday-payout?amount=${payOutAmount}`);
      toast.success(
        t(
          "We have received your request.Your holiday pay amount will credited shortly"
        )
      );
    } catch (err) {
      toast.error(t("Something went wrong"));
    } finally {
      downloadData();
      setPayOutAmount(0);
      setPayShow(false);
    }
  };

  const handlePayOutAmout = () => {
    if (
      payOutAmount < 1000 ||
      payOutAmount > incomeData.values?.holidaySavingsAmount
    ) {
      setToolTipError({
        lessPayAmount: true,
      });
    } else {
      holidayPayoutRequest();
    }
  };
  const handlePayAmountChange = (e) => {
    setPayOutAmount(e.target.value);
    if (e.target.value > 4999) {
      setHideNote(true);
    } else {
      setHideNote(false);
    }
  };

  let items = [];
  let paginationNumber = totalCount / pageCount;

  for (let number = 1; number <= Math.round(paginationNumber); number++) {
    items.push(
      <Pagination.Item
        key={number}
        active={number === activePagination}
        onClick={() => {
          setactivePagination(number);
        }}
      >
        {number}
      </Pagination.Item>
    );
  }

  const getHolidaySavingsData = async () => {
    setLoading(true);
    try {
      const URL = `/salary/getall-employee-holidaysavings-amount?PageNumber=${activePagination}&PageSize=${pageCount}`;
      const result = await axios.get(URL);
      if (result?.status === 200) {
        setLoading(false);
        setHolidaySavingsData(result?.data?.response);
        setTotalCount(result?.data?.totalCount);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err?.response?.data?.message);
    }
  };

  useEffect(() => {
    if (!tFilterDate?.from && !tFilterDate?.to) getHolidaySavingsData();
  }, [activePagination, pageCount, tFilterDate]);

  const filterTransactionData = async () => {
    setLoading(true);

    try {
      const dateStringFrom = new Date(tFilterDate?.from)
        .toISOString()
        .split("T")[0];
      const dateStringTo = new Date(tFilterDate?.to)
        .toISOString()
        .split("T")[0];

      const URL = `/salary/getall-employee-holidaysavings-amount?PageNumber=${activePagination}&PageSize=${pageCount}&fromDate=${dateStringFrom}&toDate=${dateStringTo}`;
      const result = await axios.get(URL);
      if (result?.status === 200) {
        setLoading(false);
        setHolidaySavingsData(result?.data?.response);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err?.response?.data?.message);
    }
  };

  useEffect(() => {
    if (tFilterDate?.from && tFilterDate?.to) {
      filterTransactionData();
    }
  }, [tFilterDate.from, tFilterDate?.to]);

  // API Call for Pdf Modal Data
  const [getTransaction, setgetTransaction] = useState([]);
  const [getPayoutHistory, setgetPayoutHistory] = useState([]);
  const [totalSavings, settotalSavings] = useState(0);

  const getFilteredTransactionHistory = async () => {
    try {
      let URL;
      if (showAllHistory) {
        URL = `/salary/getall-employee-holidaysavings-transaction-history`;
      } else if (filteredYear && !filteredMonth) {
        URL = `/salary/getall-employee-holidaysavings-transaction-history?year=${filteredYear}-01-01`;
      } else if (filteredYear && filteredMonth) {
        const firstDateOfMonth = new Date(filteredYear, filteredMonth - 1, 1);
        firstDateOfMonth.setDate(firstDateOfMonth.getDate() + 1);
        const formattedFirstDate = firstDateOfMonth.toISOString().split("T")[0];
        URL = `/salary/getall-employee-holidaysavings-transaction-history?Month=${formattedFirstDate}`;
      }
      if (URL) {
        setLoading(true);
        const result = await axios.get(URL);
        if (result?.status === 200) {
          setLoading(false);
          setgetTransaction(result?.data?.response);
          const total = result?.data?.response.reduce(
            (sum, transaction) => sum + (transaction.holidaySavingsAmount || 0),
            0
          );
          settotalSavings(total);
        }
      }
    } catch (err) {
      setLoading(false);
      toast.error(err?.response?.data?.message);
    }
  };

  const getFilteredPayOutHistory = async () => {
    try {
      let URL;
      if (showAllHistoryPayout) {
        URL = `/salary/holiday-payout-recived?type=1`;
      } else if (filteredYearPayout && !filteredMonthPayout) {
        URL = `/salary/holiday-payout-recived?year=${filteredYearPayout}-01-01&type=1`;
      } else if (filteredYearPayout && filteredMonthPayout) {
        const firstDateOfMonth = new Date(
          filteredYearPayout,
          filteredMonthPayout - 1,
          1
        );
        firstDateOfMonth.setDate(firstDateOfMonth.getDate() + 1);
        const formattedFirstDate = firstDateOfMonth.toISOString().split("T")[0];
        URL = `/salary/holiday-payout-recived?Month=${formattedFirstDate}&type=1`;
      }
      if (URL) {
        setLoading(true);
        const result = await axios.get(URL);
        if (result?.status === 200) {
          setLoading(false);
          setgetPayoutHistory(result?.data?.response);
        }
      }
    } catch (err) {
      setLoading(false);
      toast.error(err?.response?.data?.message);
    }
  };

  useEffect(() => {
    if (show.PDFModal) {
      getFilteredPayOutHistory();
    }
  }, [
    show.PDFModal,
    filteredYearPayout,
    filteredMonthPayout,
    showAllHistoryPayout,
  ]);

  useEffect(() => {
    if (show.PDFModal) {
      getFilteredTransactionHistory();
    }
  }, [show.PDFModal, filteredYear, filteredMonth, showAllHistory]);

  useEffect(() => {
    mobileScroll();
  }, []);

  return (
    <Layout
      className="p-4 mt-5 holiday_main invoice-space2 holiday-space"
      showSidebar
      bgcolor
    >
      <Helmet>
        {language === LOCALES.EN_US ? (
          <link
            rel="canonical"
            href="https://invozio.com/dashboard/economy/holiday-pay"
          />
        ) : (
          <link
            rel="canonical"
            href="https://invozio.com/instrumentbrada/ekonomi/semesterlon"
          />
        )}
      </Helmet>
      {loading && <Loader />}

      <div className="page-content">
        <PayoutFilter
          toolTipError={toolTipError}
          t={t}
          setDate={setDate}
          downloadData={downloadData}
        />

        <HolidayPayAmount
          spinner={spinner}
          date={date}
          incomeData={incomeData}
          isPayShow={isPayShow}
          hideNote={hideNote}
          toolTipError={toolTipError}
          handlePayAmountChange={handlePayAmountChange}
          t={t}
          setPayShow={setPayShow}
          payOutAmount={payOutAmount}
          handlePayOutAmout={handlePayOutAmout}
          setShow={setShow}
        />

        <HolidayTransactionHistory
          t={t}
          holidaySavingsData={holidaySavingsData}
          tFilterDate={tFilterDate}
          setTFilterDate={setTFilterDate}
        />

        <div className="paginationInvoice">
          <Pagination style={{ flexWrap: "wrap" }}>{items}</Pagination>
          <br />
        </div>
      </div>

      {/* Download pdf Modal */}
      <HolidayPayPDFModal
        show={show}
        t={t}
        setShow={setShow}
        incomeData={incomeData}
        totalSavings={totalSavings}
        getTransaction={getTransaction}
        getPayoutHistory={getPayoutHistory}
        handleDownloadPDF={handleDownloadPDF}
        filteredMonth={filteredMonth}
        setFilteredMonth={setFilteredMonth}
        filteredYear={filteredYear}
        setFilteredYear={setFilteredYear}
        showAllHistory={showAllHistory}
        setShowAllHistory={setShowAllHistory}
        showAllHistoryPayout={showAllHistoryPayout}
        setShowAllHistoryPayout={setShowAllHistoryPayout}
        filteredMonthPayout={filteredMonthPayout}
        setFilteredMonthPayout={setFilteredMonthPayout}
        filteredYearPayout={filteredYearPayout}
        setFilteredYearPayout={setFilteredYearPayout}
      />
    </Layout>
  );
};

export default HolidayPay;
